import { Button } from "@/components/ui/button";
import { NativeOverlaySheet } from "@/components/native/NativeOverlaySheet";
import { useLanguage } from "@/context/LanguageContext";
import { carDetailsLabels } from "@/i18n";

interface AutoBidOverBuyNowSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  buyNowPrice: number;
  /** When rounding pushed the ceiling above buy-now */
  roundedAmount?: number | null;
}

export const AutoBidOverBuyNowSheet = ({
  open,
  onOpenChange,
  buyNowPrice,
  roundedAmount = null,
}: AutoBidOverBuyNowSheetProps) => {
  const { language } = useLanguage();
  const bi = carDetailsLabels(language).biddingInfo;
  const fmt = (n: number) => n.toLocaleString("sv-SE");

  const description =
    roundedAmount != null
      ? bi.autoBidRoundedOverBuyNowDesc
          .replace("{rounded}", fmt(roundedAmount))
          .replace("{buyNow}", fmt(buyNowPrice))
      : bi.autoBidOverBuyNowDesc.replace("{amount}", fmt(buyNowPrice));

  return (
    <NativeOverlaySheet
      open={open}
      onOpenChange={onOpenChange}
      title={bi.autoBidOverBuyNowTitle}
    >
      <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
      <Button
        type="button"
        className="w-full mt-4 bg-accent hover:bg-accent/90 text-black"
        onClick={() => onOpenChange(false)}
      >
        {bi.close}
      </Button>
    </NativeOverlaySheet>
  );
};
